import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/common/ScrollToTop";
import ScrollToTopButton from "./components/common/ScrollToTopButton";

// Pages
import HomePage from "./pages/HomePage";
import ComparisonPage from "./pages/ComparisonPage";
import InquiryPage from "./pages/InquiryPage";
import ConsultationPage from "./pages/ConsultationPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import ImprintPage from "./pages/ImprintPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import PartnerPage from "./pages/PartnerPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vergleich" element={<ComparisonPage />} />
          <Route path="/anfrage" element={<InquiryPage />} />
          <Route path="/beratung" element={<ConsultationPage />} />
          <Route path="/ueber-uns" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/impressum" element={<ImprintPage />} />
          <Route path="/datenschutz" element={<PrivacyPage />} />
          <Route path="/agb" element={<TermsPage />} />
          <Route path="/partner" element={<PartnerPage />} />
        </Routes>
        <ScrollToTopButton />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
